window.searchBoost = (function () {
  const ENDPOINT = 'https://awe-conversion.bestworlds.com/api/search-boost';
  const cache = {};

  function lookup(term) {
    const key = String(term || '').toLowerCase().trim();
    if (!key || key.indexOf('variants.sku:') === 0 || /^\d{4}-\d{5}$/.test(key)) {
      return Promise.resolve([]);
    }
    if (!cache[key]) {
      cache[key] = fetch(ENDPOINT + '?q=' + encodeURIComponent(key))
        .then((response) => (response.ok ? response.json() : { products: [] }))
        .then((data) => (Array.isArray(data.products) ? data.products : []))
        .catch(() => []);
    }
    return cache[key];
  }

  function cards(handles, limit) {
    const list = handles.slice(0, Number(limit) || handles.length);
    return Promise.all(list.map((handle) =>
      fetch('/products/' + handle + '?view=ajax_section_recently_viewed')
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '')
    )).then((parts) => parts.join(''));
  }

  function toListItems(html) {
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    return Array.from(wrap.children).map((node) => {
      const item = document.createElement('li');
      item.className = node.className;
      item.innerHTML = node.innerHTML;
      return item;
    });
  }

  function setHeadingCount(heading, count) {
    const target = heading?.querySelector('.search-boost-heading') || heading;
    if (!target) return;
    const label = count === 1 ? 'result' : 'results';
    if (/^\d+\s+results?/.test(target.textContent)) {
      target.textContent = target.textContent.replace(/^\d+\s+results?/, count + ' ' + label);
      return;
    }
    const previous = heading.dataset.searchHeadingCount;
    if (previous) target.textContent = target.textContent.replace(previous, String(count));
  }

  function refreshMoney() {
    if (window.$ && $('.dropdown-item[data-currency]').length && window.Currency) {
      if ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
      }
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
  }

  function renderBoostCards(section, products, layout) {
    return cards(products.map((product) => product.handle), products.length).then((html) => {
      const items = toListItems(html);
      if (!items.length) return false;
      const grid = section.querySelector('#main-collection-product-grid');
      if (grid && grid.tagName === 'UL') {
        grid.replaceChildren.apply(grid, items);
      } else {
        const page = section.querySelector('#CollectionProductGrid');
        if (!page) return false;
        const collection = document.createElement('div');
        collection.className = 'collection resultListing';
        const list = document.createElement('ul');
        list.id = 'main-collection-product-grid';
        list.className = 'productListing productGrid column-' + (layout || 4) + ' list-' + (layout || 4) + ' list-unstyled';
        list.replaceChildren.apply(list, items);
        collection.appendChild(list);
        page.replaceChildren(collection);
      }
      section.querySelectorAll('.pagination-wrapper, .pagination-infinite').forEach((node) => node.remove());
      setHeadingCount(section.querySelector('.search-boost-heading-wrap'), products.length);
      section.dataset.searchCount = String(products.length);
      refreshMoney();
      return true;
    });
  }

  function applyToSearchPage(options) {
    const section = document.getElementById('SearchSection-' + options.sectionId);
    if (!section) return;

    section.classList.add('is-loading');

    const boostTask = lookup(options.term).then((products) => {
      if (!products.length) return false;
      section.dataset.searchBoost = '1';
      section.querySelectorAll('.pagination-wrapper, .pagination-infinite').forEach((node) => node.remove());
      return renderBoostCards(section, products, options.layout);
    }).catch(() => false);

    const matchTask = options.waitForMatchCount && window.searchMatchCount
      ? window.searchMatchCount(window.location.href).catch(() => null)
      : Promise.resolve(null);

    Promise.all([boostTask, matchTask]).then(([boosted, matchCount]) => {
      if (boosted || matchCount == null) return;
      setHeadingCount(section.querySelector('.search-boost-heading-wrap'), matchCount);
      section.dataset.searchCount = String(matchCount);
    }).finally(() => {
      section.classList.remove('is-loading');
    });
  }

  return {
    lookup: lookup,
    cards: cards,
    applyToSearchPage: applyToSearchPage
  };
})();
